export default "__VITE_ASSET__rMBKNsSE__"